import React from 'react'
import Stats from './Stats'
import Charts from './Charts'
import TableStatus from './TableStatus'

const Home = () => {
  return (
    <div>
        <Stats/>
        <Charts/>
        <TableStatus/>
    </div>
  )
}

export default Home